/* Henley Spirit: chain picker + Make it a set (sections/main-product-henley-set.liquid). Chain card thumbnails use real chain photos.
   2026-10-31 (hayden): the chain picker is two steps now - a row of chain tiles, then one shared row of lengths
   underneath - instead of five stacked rows each with their own hidden length buttons. The markup hooks moved to
   data attributes (data-hs-chain-btn, data-hs-chain-img, data-hs-chain-name, data-hs-chain-price-slot,
   data-hs-length-block, data-hs-chain-desc) so the old .hs-cc row styles no longer apply. */
(function () {
const ASSET_BASE = ((document.currentScript && document.currentScript.src) || '').replace(/henley-pendant-set\.js.*$/, '');
// The Pendant Only card shows a cut-out of the pendant with no chain, from Shopify Files: hs-pendant-only-<key>.webp (card, 300px) and hs-pendant-zoom-<key>.webp (enlarged, 640px).
// key = handle without -pendant-market (both Greek Head pairings share silver-gold-greek-head).
const pendantOnlyPhoto = (kind) => {
const match = location.pathname.match(/\/products\/([^/?#]+-pendant(?:-(?:silver|gold)-pairing)?-market)(?:[/?#]|$)/);
if (!match) return '';
return 'https://cdn.shopify.com/s/files/1/0888/2366/0873/files/hs-pendant-' + (kind || 'only') + '-' + match[1].replace(/-pendant(-(silver|gold)-pairing)?-market$/, '') + '.webp';
};
const toHandle = (text) => String(text).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
function initChains(page, section) {
const wrap = section.querySelector('[data-hs-chains]');
if (!wrap) return;
const chainIndex = parseInt(wrap.dataset.chainIndex, 10);
const lengthIndex = parseInt(wrap.dataset.lengthIndex, 10);
const recLength = wrap.dataset.recLength;
const cards = Array.from(wrap.querySelectorAll('[data-hs-chain]'));
const recommended = cards.filter((c) => c.querySelector('.hs-rec'))[0];
if (recommended && wrap.firstElementChild !== recommended) wrap.insertBefore(recommended, wrap.firstElementChild);
const aside = section.querySelector('[data-hs-aside]');
const asideText = section.querySelector('[data-hs-aside-text]');
const lenBlock = section.querySelector('[data-hs-length-block]');
const lenBtns = Array.from(section.querySelectorAll('[data-hs-len]'));
const note = section.querySelector('[data-hs-note]');
const descOut = section.querySelector('[data-hs-chain-desc]');
let stock = {};
let notes = {};
try {
stock = JSON.parse(section.querySelector('[data-hs-stock]').textContent) || {};
} catch (error) {
stock = {};
}
try {
JSON.parse(section.querySelector('[data-hs-length-notes]').textContent).forEach((line) => {
const parts = String(line).split(':');
if (parts.length > 1) notes[parts.shift().trim()] = parts.join(':').trim();
});
} catch (error) {
notes = {};
}
const variantFor = (chain, length) =>
page.variants.filter(
(v) => v.options[chainIndex] === chain && (lengthIndex < 0 || v.options[lengthIndex] === length)
)[0];
const lengthsFor = (chain) =>
page.variants
.filter((v) => v.options[chainIndex] === chain && v.available)
.map((v) => (lengthIndex < 0 ? null : v.options[lengthIndex]));
// Every length this chain is sold in, sold out ones included, so the shared row can hide the
// lengths that do not belong to the chain the shopper just picked.
const lengthsOffered = (chain) =>
page.variants
.filter((v) => v.options[chainIndex] === chain)
.map((v) => (lengthIndex < 0 ? null : v.options[lengthIndex]));
const pickLength = (chain, preferred) => {
const lengths = lengthsFor(chain);
if (!lengths.length) return null;
if (lengths.indexOf(preferred) > -1) return preferred;
if (lengths.indexOf(recLength) > -1) return recLength;
return lengths[0];
};
const sync = () => {
const chain = page.selectedOptions[chainIndex];
const length = lengthIndex < 0 ? null : page.selectedOptions[lengthIndex];
let picked = null;
cards.forEach((card) => {
const on = card.dataset.hsChain === chain;
if (on) picked = card;
card.classList.toggle('hs-on', on);
const btn = card.querySelector('[data-hs-chain-btn]');
if (btn) btn.setAttribute('aria-checked', on);
});
if (descOut) {
const src = picked ? picked.querySelector('[data-hs-chain-desc-src]') : null;
const text = src ? src.textContent.trim() : '';
descOut.textContent = text;
descOut.hidden = !text;
}
const offered = lengthsOffered(chain);
const distinct = offered.filter((value, index) => offered.indexOf(value) === index);
const showLengths = lengthIndex >= 0 && distinct.length > 1;
if (lenBlock) lenBlock.hidden = !showLengths;
lenBtns.forEach((btn) => {
const value = btn.dataset.hsLen;
const has = offered.indexOf(value) > -1;
btn.hidden = !has;
const variant = has ? variantFor(chain, value) : null;
const available = !!(variant && variant.available);
btn.disabled = !available;
btn.classList.toggle('henley-unavailable', has && !available);
btn.classList.toggle('henley-active', has && value === length);
});
if (note) {
const variant = variantFor(chain, length);
const qty = variant ? stock[variant.id] : undefined;
let html = '';
if (showLengths) {
if (length === recLength) html += '<span class="hs-star" aria-hidden="true">&#9733;</span>';
if (notes[length]) html += '<span>' + notes[length] + '</span>';
}
if (qty > 0 && qty <= 3) html += (html ? '<span>&middot;</span>' : '') + '<span class="hs-low">Only ' + qty + ' left</span>';
note.innerHTML = html;
}
};
const apply = (chain, length) => {
page.selectedOptions[chainIndex] = chain;
if (lengthIndex >= 0 && length !== null) page.selectedOptions[lengthIndex] = length;
page.onSelectionChange();
sync();
section.dispatchEvent(new CustomEvent('hs:variant-change', { bubbles: true }));
};
const photosFor = (chain) => {
const groups = page.mediaGroupValues || {};
const group = Object.prototype.hasOwnProperty.call(groups, chain) ? groups[chain] : null;
if (!group || !Array.isArray(page.mediaList)) return [];
return page.mediaList
.filter((m) => m.group === group && m.src)
.slice(0, 3)
.map((m) => ({ src: m.src, caption: m.label || '' }));
};
const hasOwnPhotos = (chain) => {
const groups = page.mediaGroupValues || {};
return groups[chain] === toHandle(chain);
};
const setCardPhoto = (card, on, animate) => {
const box = card.querySelector('[data-hs-chain-img]');
if (!box) return;
if (on && !hasOwnPhotos(card.dataset.hsChain)) on = false;
let pendant = box.querySelector('.hs-ct-pend');
if (on && !pendant) {
const photo = photosFor(card.dataset.hsChain)[0];
if (!photo) return;
pendant = document.createElement('img');
pendant.className = 'hs-ct-pend';
pendant.src = photo.src.replace(/([?&])width=\d+/, '$1width=300');
pendant.alt = '';
box.appendChild(pendant);
}
clearTimeout(box.hsTimer);
if (!on) {
box.classList.remove('hs-show-pend');
return;
}
if (animate) {
box.hsTimer = setTimeout(() => box.classList.add('hs-show-pend'), 450);
} else {
box.classList.add('hs-show-pend');
}
};
const toNumber = (html) => parseFloat(String(html).replace(/[^0-9.]/g, '')) || 0;
// Tile prices read as a difference, not a price list: whatever most chains cost is "Included" and
// the odd ones out show what they add or take off. Four identical prices in a row said nothing.
const cheapestBy = {};
cards.forEach((card) => {
const options = page.variants.filter((v) => v.options[chainIndex] === card.dataset.hsChain);
if (options.length) cheapestBy[card.dataset.hsChain] = options.reduce((a, b) => (toNumber(b.priceHtml) < toNumber(a.priceHtml) ? b : a));
});
const keys = Object.keys(cheapestBy);
const amounts = keys.map((k) => toNumber(cheapestBy[k].priceHtml));
let base = 0;
let bestCount = 0;
amounts.forEach((value) => {
const count = amounts.filter((other) => other === value).length;
if (count > bestCount || (count === bestCount && value < base)) {
base = value;
bestCount = count;
}
});
const symbol = keys.length ? (String(cheapestBy[keys[0]].priceHtml).match(/^[^0-9]*/) || [''])[0].trim() : '';
cards.forEach((card) => {
const slot = card.querySelector('[data-hs-chain-price-slot]');
const cheapest = cheapestBy[card.dataset.hsChain];
if (!slot || !cheapest || slot.querySelector('.hs-ct-price')) return;
const amount = toNumber(cheapest.priceHtml);
const price = document.createElement('span');
price.className = 'hs-ct-price';
if (amount === base) {
price.textContent = 'Included';
} else {
const diff = amount - base;
price.classList.add(diff > 0 ? 'hs-ct-up' : 'hs-ct-down');
price.textContent = (diff > 0 ? '+' : '−') + symbol + Math.abs(diff).toFixed(2).replace(/\.00$/, '');
}
slot.appendChild(price);
});
cards.forEach((card) => {
const chain = card.dataset.hsChain;
const thumb = card.querySelector('[data-hs-chain-img] img');
if (thumb) {
chainThumb(thumb, chain);
// The tile itself picks the chain, so the zoom moved to the small magnifier on the photo.
const zoomBtn = card.querySelector('[data-hs-zoom]') || thumb.parentElement;
zoomBtn.addEventListener('click', (event) => {
event.preventDefault();
event.stopPropagation();
const name = card.querySelector('[data-hs-chain-name]');
const label = name ? name.firstChild.textContent.trim() : chain;
const cutout = /pendant only/i.test(chain) ? pendantOnlyPhoto('zoom') : '';
openZoom(
thumb.currentSrc || thumb.src,
label,
cutout ? [{ src: cutout, caption: label }] : !hasOwnPhotos(chain) ? [] : photosFor(chain)
);
});
}
const row = card.querySelector('[data-hs-chain-btn]');
if (!row) return;
row.addEventListener('click', () => {
if (card.classList.contains('hs-sold') || chain === page.selectedOptions[chainIndex]) return;
const length = lengthIndex < 0 ? null : pickLength(chain, page.selectedOptions[lengthIndex]);
apply(chain, length);
cards.forEach((other) => setCardPhoto(other, other === card, true));
if (aside) {
aside.classList.add('hs-done');
if (asideText) asideText.textContent = 'Now showing ' + chain + ' photos';
}
});
});
lenBtns.forEach((btn) => {
btn.addEventListener('click', () => {
if (btn.disabled) return;
apply(page.selectedOptions[chainIndex], btn.dataset.hsLen);
});
});
sync();
[300, 1500].forEach((wait) =>
setTimeout(() => cards.forEach((card) => setCardPhoto(card, card.classList.contains('hs-on'), false)), wait)
);
}
const CHAIN_PHOTO = {
silver: {
rope: 'Rope_Chain_Silver_3mm_Top_Shot_Close_up.jpg?v=1784032482',
cuban: 'Silver_4mm_Cuban_Chain_Top_Shot.jpg?v=1782410228',
curb: 'Curb_Chain_Silver_2mm_Top_Shot.jpg?v=1782413260',
figaro: 'Figaro_Chain_Silver_5mm_Top_Shot.jpg?v=1782479275',
},
gold: {
rope: 'Rope_Chain_Gold_3mm_Top_View.jpg?v=1782411412',
cuban: 'Cuban_Chain_Gold_4mm_Top_Shot.jpg?v=1782410644',
curb: 'Curb_Chain_Gold_2mm_Top_Shot.jpg?v=1782414838',
figaro: 'Figaro_Chain_Gold_5mm_Top_Shot.jpg?v=1782479452',
},
};
function chainThumb(thumb, chain) {
const kind = /rope/i.test(chain) ? 'rope' : /cuban/i.test(chain) ? 'cuban' : /curb/i.test(chain) ? 'curb' : /figaro/i.test(chain) ? 'figaro' : '';
if (!kind) {
const only = /pendant only/i.test(chain) ? pendantOnlyPhoto() : '';
if (only) {
thumb.removeAttribute('srcset');
thumb.src = only;
}
return;
}
const metal = thumb.closest('[data-hs-metal]');
const title = document.querySelector('.henley-product-title');
const gold = metal ? metal.dataset.hsMetal === 'gold' : /\bgold\b/i.test((title && title.textContent) || '') || /\/products\/gold-/.test(location.pathname);
thumb.removeAttribute('srcset');
if (ASSET_BASE) {
thumb.src = ASSET_BASE + 'hs-chain-45-' + (gold ? 'gold' : 'silver') + '-' + kind + '.webp';
return;
}
const file = CHAIN_PHOTO[gold ? 'gold' : 'silver'][kind];
thumb.src = 'https://cdn.shopify.com/s/files/1/0888/2366/0873/files/' + file + '&width=300';
}
let zoom = null;
function buildZoom() {
if (zoom) return;
zoom = document.createElement('div');
zoom.className = 'hs-zoom';
zoom.setAttribute('role', 'dialog');
zoom.setAttribute('aria-modal', 'true');
zoom.innerHTML =
'<button type="button" class="hs-zoom-x" aria-label="Close">&times;</button>' +
'<div class="hs-zoom-track"></div><div class="hs-zoom-dots"></div><p></p>';
document.body.appendChild(zoom);
const close = () => {
zoom.classList.remove('hs-open');
document.body.style.overflow = '';
};
zoom.addEventListener('click', (event) => {
if (event.target === zoom || event.target.closest('.hs-zoom-x')) close();
});
document.addEventListener('keydown', (event) => {
if (event.key === 'Escape' && zoom.classList.contains('hs-open')) close();
});
const track = zoom.querySelector('.hs-zoom-track');
let scrollWait;
track.addEventListener('scroll', () => {
clearTimeout(scrollWait);
scrollWait = setTimeout(() => {
if (zoom.setSlide) zoom.setSlide(Math.round(track.scrollLeft / (track.clientWidth || 1)), false);
}, 80);
});
}
function openZoom(src, caption, extras) {
buildZoom();
const track = zoom.querySelector('.hs-zoom-track');
const dots = zoom.querySelector('.hs-zoom-dots');
const text = zoom.querySelector('p');
const slides = (extras || []).length
? extras.map((s) => ({ src: s.src, caption: s.caption || caption + ' on this pendant' }))
: [{ src: src.replace(/([?&])width=\d+/, '$1width=1200'), caption: caption }];
function setSlide(index, move) {
if (!slides[index]) return;
if (move) track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
text.textContent = slides[index].caption;
dots.querySelectorAll('button').forEach((d, i) => d.classList.toggle('hs-on', i === index));
}
zoom.setSlide = setSlide;
track.innerHTML = '';
dots.innerHTML = '';
slides.forEach((slide, index) => {
const img = document.createElement('img');
img.src = slide.src;
img.alt = slide.caption;
track.appendChild(img);
if (slides.length > 1) {
const dot = document.createElement('button');
dot.type = 'button';
dot.setAttribute('aria-label', slide.caption);
dot.addEventListener('click', () => setSlide(index, true));
dots.appendChild(dot);
}
});
track.scrollLeft = 0;
setSlide(0, false);
zoom.classList.add('hs-open');
document.body.style.overflow = 'hidden';
zoom.querySelector('.hs-zoom-x').focus();
}
function initSet(page, section) {
const box = section.querySelector('[data-hs-setbox]');
if (!box) return;
const head = box.querySelector('[data-hs-set-head]');
const track = box.querySelector('[data-hs-car-track]');
const sub = box.querySelector('[data-hs-set-sub]');
const subText = box.querySelector('[data-hs-set-sub-text]');
const ctaText = box.querySelector('[data-hs-cta-text]');
const ctaDefault = ctaText ? ctaText.textContent : '';
const gift = section.querySelector('[data-hs-gift]');
const giftPrice = gift ? gift.querySelector('[data-hs-addon-price]') : null;
head.addEventListener('click', () => {
const open = box.classList.toggle('hs-open');
head.setAttribute('aria-expanded', open);
});
box.querySelectorAll('[data-hs-car]').forEach((btn) => {
btn.addEventListener('click', () => {
track.scrollBy({ left: 160 * parseInt(btn.dataset.hsCar, 10), behavior: 'smooth' });
});
});
const refresh = () => {
const added = box.querySelectorAll('[data-hs-set-item].henley-selected').length;
sub.classList.toggle('hs-ok', added > 0);
subText.textContent = added
? added + ' chain' + (added > 1 ? 's' : '') + ' added' + (gift ? ' · free gift packaging included' : '')
: subText.dataset.default;
if (ctaText) ctaText.textContent = added ? 'Edit set' : ctaDefault;
if (gift) {
gift.classList.toggle('hs-free', added > 0);
gift.classList.toggle('henley-selected', added > 0 || gift.dataset.hsUserPicked === 'true');
if (giftPrice) {
giftPrice.innerHTML = added
? '<span class="hs-freetag">Free with set</span> <s>' + giftPrice.dataset.default.replace('+ ', '') + '</s>'
: giftPrice.dataset.default;
}
}
};
box.querySelectorAll('[data-hs-set-card]').forEach((card) => {
const item = card.querySelector('[data-hs-set-item]');
const addBtn = card.querySelector('[data-hs-set-add]');
const addLabel = addBtn.textContent;
const priceEl = card.querySelector('[data-hs-set-price]');
const wasEl = card.querySelector('[data-hs-set-was]');
const badge = card.querySelector('.hs-sc-save');
let saveEl = null;
if (priceEl && wasEl) {
saveEl = document.createElement('div');
saveEl.className = 'hs-sc-saving';
priceEl.parentElement.insertAdjacentElement('afterend', saveEl);
}
const showSaving = () => {
if (!saveEl) return;
const amount = (el) => parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0;
const now = amount(priceEl);
const was = amount(wasEl);
if (!was || now >= was) {
saveEl.textContent = '';
return;
}
const symbol = (priceEl.textContent.match(/^[^0-9]*/) || [''])[0].trim();
if (badge) badge.textContent = Math.round((1 - now / was) * 100) + '% OFF';
saveEl.textContent = 'You save ' + symbol + (was - now).toFixed(2);
};
showSaving();
card.querySelectorAll('[data-hs-set-variant]').forEach((btn) => {
btn.addEventListener('click', () => {
if (btn.disabled) return;
card.querySelectorAll('[data-hs-set-variant]').forEach((b) => b.classList.toggle('hs-on', b === btn));
item.dataset.henleyAddon = btn.dataset.hsSetVariant;
if (priceEl) priceEl.textContent = btn.dataset.price;
if (wasEl) wasEl.textContent = btn.dataset.was;
showSaving();
});
});
addBtn.addEventListener('click', () => {
const on = !item.classList.contains('henley-selected');
item.classList.toggle('henley-selected', on);
card.classList.toggle('hs-added', on);
addBtn.innerHTML = on ? addBtn.dataset.addedLabel : addLabel;
refresh();
});
});
if (gift) {
gift.addEventListener(
'click',
(event) => {
if (gift.classList.contains('hs-free')) {
event.stopImmediatePropagation();
return;
}
setTimeout(() => {
gift.dataset.hsUserPicked = gift.classList.contains('henley-selected') ? 'true' : 'false';
}, 0);
},
true
);
}
refresh();
}
function init(section) {
const page = section.querySelector('henley-product-page');
if (!page || page.dataset.hsReady) return;
page.dataset.hsReady = 'true';
section.querySelectorAll('.henley-bullets li').forEach((li) => {
if (/^\s*paired with/i.test(li.textContent)) li.remove();
});
initChains(page, section);
initSet(page, section);
}
function boot() {
customElements.whenDefined('henley-product-page').then(() => {
document.querySelectorAll('.hs-chain-page').forEach(init);
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', boot);
} else {
boot();
}
document.addEventListener('shopify:section:load', boot);
})();